/**
 * Collapses `.` and `..` path segments (POSIX-style, no filesystem access).
 */
export function normalizePathSegmentList(
  segments: readonly string[]
): string[] {
  const normalized: string[] = [];
  for (const segment of segments) {
    if (segment === '' || segment === '.') {
      continue;
    }
    if (segment === '..') {
      normalized.pop();
      continue;
    }
    normalized.push(segment);
  }
  return normalized;
}

/** Normalizes slash-separated paths to a leading-slash absolute path. */
export function normalizePathSegments(path: string): string {
  const normalized = normalizePathSegmentList(path.split('/').filter(Boolean));
  return `/${normalized.join('/')}`;
}
